import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { BankAccount, RequestWithdrawalResult, Wallet } from 'interfaces';
import { BsChevronDown } from 'react-icons/bs';
import { Spin } from 'antd';
import { Button, Input, PayaCyclesButton } from '../../../components';
import CoinIcon from '../../../../utilities/components/coinIcon/coinIcon.index';
import { getIBans } from 'services';
import { deleteCommaSeparator, detectBankByName, faNumToEnNum } from 'scripts';
import { requestWithdrawal } from './irtWithdrawal.service';
import WithdrawalModal from './withdrawalModal/withdrawal-modal.index';
import { IBanSelectionModal } from '../../deposit/iBanSelectionModal/iBanSelectionModal.index';

interface Props {
    wallet?: Wallet;
    hideBalances: boolean;
    setHideBalances: Dispatch<SetStateAction<boolean>>;
}
export const IRTWithdrawal: FC<Props> = (props) => {
    const [iBansLoading, setIBansLoading] = useState(true);
    const [iBans, setIBans] = useState<Omit<BankAccount, 'cardNumber'>[]>();
    const [selectedIBan, setSelectedIBan] = useState<Omit<BankAccount, 'cardNumber'>>();
    const [amount, setAmount] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);
    const [requestWithdrawalResult, setRequestWithdrawalResult] = useState<RequestWithdrawalResult | undefined>();
    const [withdrawalModalOpen, setWithdrawalModalOpen] = useState<boolean>(false);
    const [iBansModalOpen, setIBansModalOpen] = useState<boolean>(false);

    const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = deleteCommaSeparator(faNumToEnNum(e.target.value));
        const numericValue = Number(inputValue);

        if (inputValue === '' || isNaN(numericValue)) {
            setAmount(undefined);
        } else {
            setAmount(numericValue);
        }
    };

    const onAllBalanceInput = () => {
        setAmount(props.wallet?.assets?.find((asset) => asset?.symbol?.toUpperCase() === 'IRT')?.available);
    };

    const onIBanSelection = (iBan: Omit<BankAccount, 'cardNumber'>) => {
        setSelectedIBan(iBan);
        setIBansModalOpen(false);
    };

    const onSubmit = () => {
        if (amount && selectedIBan) {
            const onComplete = () => {
                setWithdrawalModalOpen(true);
            };

            requestWithdrawal(
                setLoading,
                {
                    amount,
                    IBanNumberId: selectedIBan?.id,
                    platform: 1,
                },
                setRequestWithdrawalResult,
                onComplete,
            );
        }
    };

    useEffect(() => {
        getIBans(setIBansLoading, setIBans, setSelectedIBan);
    }, []);

    return (
        <div className={'flex flex-col m-6'}>
            {iBans && (
                <IBanSelectionModal
                    open={iBansModalOpen}
                    setOpen={setIBansModalOpen}
                    iBans={iBans}
                    onSelect={onIBanSelection}
                />
            )}
            {requestWithdrawalResult && amount && selectedIBan && (
                <WithdrawalModal
                    open={withdrawalModalOpen}
                    setOpen={setWithdrawalModalOpen}
                    bankAccountId={selectedIBan?.id}
                    amount={amount}
                    requestWithdrawalResult={requestWithdrawalResult}
                />
            )}
            <label className={'max-lg:text-sm'}>شماره شبا:</label>
            <Spin spinning={iBansLoading}>
                <div
                    className={
                        'flex justify-between items-center border border-primary-40 rounded-[28px] text-base px-6 h-14 w-full max-lg:h-12 max-lg:text-sm mt-2 clickable'
                    }
                    onClick={() => setIBansModalOpen(true)}
                >
                    {selectedIBan && (
                        <>
                            <img src={detectBankByName(selectedIBan?.bank?.name)?.bank_logo} className={'w-6 h-6'} />
                            {selectedIBan?.iBan}
                            <BsChevronDown />
                        </>
                    )}
                </div>
            </Spin>
            <PayaCyclesButton className={'mt-3'} />
            <label className={'mt-4 max-lg:text-sm'}>مبلغ برداشتی (تومان):</label>
            <Input
                placeholder={'مبلغ برداشتی را وارد نمایید...'}
                className={'mt-2'}
                inputMode={'numeric'}
                type={'text'}
                value={amount?.toLocaleString()}
                onChange={handleAmountChange}
                suffix={<CoinIcon symbol={'IRT'} className={'mr-2'} />}
                dir={amount ? 'ltr' : 'rtl'}
            />
            <div className={'flex justify-between mt-4 items-center'}>
                <div className={'flex items-center gap-2'}>
                    <div className={'rounded-full bg-primary-100 w-2 h-2'} />
                    <p className={'font-bold text-base max-lg:text-xs'}>خالص دریافتی:</p>
                    <span className={'font-bold text-base max-lg:text-sm'}>{amount?.toLocaleString()}</span>
                    <span className={'font-medium text-base max-lg:text-xs'}>تومان</span>
                </div>
                <div
                    className={'font-bold text-base clickable text-primary-100 max-lg:text-xs'}
                    onClick={onAllBalanceInput}
                >
                    انتخاب کل موجودی
                </div>
            </div>
            <Button
                disabled={!selectedIBan || loading || !amount}
                loading={loading}
                className={'mt-6'}
                type={'primary'}
                onClick={onSubmit}
            >
                برداشت
            </Button>
        </div>
    );
};
